import script from "./footer-bar.vue?vue&type=script&lang=ts&setup=true"
export * from "./footer-bar.vue?vue&type=script&lang=ts&setup=true"

import "./footer-bar.vue?vue&type=style&index=0&id=79a48f03&lang=less&scoped=true"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.2.2_vue@3.3.13_webpack@5.88.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-79a48f03"]])

export default __exports__